import React, { useState, useMemo } from 'react'
import { LoadingStateContext, LoadingActionsContext } from './loadingContexts'

export const LoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [loadingCount, setLoadingCount] = useState(0)

  const actions = useMemo(() => ({
    startLoading: () => setLoadingCount(prev => prev + 1),
    stopLoading: () => setLoadingCount(prev => Math.max(0, prev - 1)),
  }), [])

  const state = useMemo(() => ({
    isLoading: loadingCount > 0,
  }), [loadingCount])

  return (
    <LoadingActionsContext.Provider value={actions}>
      <LoadingStateContext.Provider value={state}>
        {children}
      </LoadingStateContext.Provider>
    </LoadingActionsContext.Provider>
  )
}
